<template>
  <div class="be-content">
    <div class="main-content container-fluid">
      <h3 class="text-center">{{operator.name}}</h3>
      <h4 class="text-center">Рег. №: {{operator.id}}</h4>
      <div class="panel">
        <div class="panel-heading panel-heading-divider">Импортирование данных из файла xml</div>
        <div class="panel-body">
          <form enctype="multipart/form-data">
            <button onclick="file='';javascript:document.getElementById('file').click()" type="button"
                    class="btn btn-default btn-lg">
              <i class="icon mdi mdi-upload"></i> Выбрать файл XML(zip) ...
            </button>
            <input type="file" style="visibility: hidden" id="file" ref="file"
                   v-on:change="handleFileUpload()"/>
          </form>
          <div v-if="messages" class=" col-lg-4 alert alert-danger">
            {{messages}}
          </div>
          <div v-if="dataIsLoading" class="col-lg-12">
            <vue-simple-spinner :font-size="20"
                                message="Идёт обработка файла. Дождитесь завершения операции."></vue-simple-spinner>
          </div>
          <div class="row be-datatable-body" v-if="guestVisits && !dataIsLoading">
            <div class="col-sm-12">
              <div class="panel-heading text-center">Предварительный просмотр импортируемых данных
              </div>
              <table class="table table-hover table-fw-widget dataTable no-footer">
                <thead>
                <tr>
                  <th>#</th>
                  <th style="width: 15%">Ф.И.О.</th>
                  <th>Дата заезда</th>
                  <th>Дата выезда</th>
                  <th style="width: 13%" class="number">
                    Количество дней <span class="mdi mdi-info" title="Количество дней фактического проживания плательщика курортного сбора, за исключением дня заезда"></span>
                  </th>
                  <th style="width: 10%" class="number">Сумма сбора, руб.</th>
                  <th>Отказ от оплаты</th>
                  <th>Льгота</th>
                  <th>Отчетный период</th>
                  <th>UniqueID</th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="guestVisits.length>0" v-for="guest, index in guestVisits"
                    :key="guest.id">
                  <td>{{index + 1}}</td>
                  <td>
                    {{get_guest_full_name(guest)}}
                  </td>
                  <td>{{guest['date_start'] | dateFilter('DD.MM.YYYY')}}</td>
                  <td :class="{'text-danger': !datePeriodIsCorrect(guest['date_start'], guest['date_end'])}">
                    {{guest['date_end'] | dateFilter('DD.MM.YYYY')}}
                    <span v-if="!datePeriodIsCorrect(guest['date_start'], guest['date_end'])"> - неверная дата!</span>
                  </td>
                  <td class="number">{{guest['taxable_period']-1}}</td>
                  <td class="number">
                    <span
                      v-if="Number(guest['tax_amount'])>0 && !guest['refusal_to_pay']">{{guest['tax_amount']}}</span>
                    <span v-else>—</span>
                  <td>
                    <span v-if="guest['refusal_to_pay']">Да</span>
                    <span v-else>Нет</span>
                  </td>
                  <td v-if="guest['privilege_category_id']">
                    Да ({{getPrivilegeCategoryCode(guest['privilege_category_id'])}})
                  </td>
                  <td v-if="guest['privilege_category_id'] === null">Нет</td>
                  <td>
                    {{guest['report']['date_start'] | dateFilter('DD.MM')}} - {{guest['report']['date_end'] | dateFilter('DD.MM.YYYY')}}
                    <span v-if="guest['report']['status']==='Submitted'" class="text-danger">Подтверждён!</span>
                  </td>
                  <td><span v-if="guest['unique_id']">{{guest['unique_id']}}</span>
                    <span v-else>—</span>
                  </td>
                </tr>
                </tbody>
              </table>
              <div v-if="!guestVisits || guestVisits.length==0" class="text-center" style="margin-top: 20px"><h4>
                Записей нет.</h4></div>
            </div>
          </div>
          <div v-if="guestVisits && guestVisits.length>0 && !dataIsLoading" class="row be-datatable-footer">
            <div class="col-sm-5">
              <div class="dataTables_info" id="table2_info" role="status" aria-live="polite">
                Всего записей: {{guestVisits.length}}.
              </div>
            </div>
          </div>
          <div v-if="dataIsImporting" class=" col-lg-12">
            <vue-simple-spinner :font-size="20"
                                message="Идёт создание(обновление) записей. Дождитесь завершения операции."></vue-simple-spinner>
          </div>
          <div v-if="guestVisits && guestVisits.length>0 && !dataIsLoading && !dataIsImporting"
               class="col-ls-12 text-center" style="margin-top: 15px">
            <button @click="submitImport" type="button"
                    class="btn btn-success btn-lg">
              <i class="icon mdi mdi-check"></i> Подтвердить импорт данных
            </button>
            <button class="btn btn-danger btn-lg" @click="$router.go(-1)">Отмена
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import {mapGetters, mapActions} from 'vuex'

  export default {
    props: ['operatorId'],
    data () {
      return {
        file: '',
        messages: null,
        guestVisits: null,
        dataIsLoading: false,
        dataIsImporting: false,
      }
    },
    computed: {
      operator () {
        return this.operators.find(op => Number(op.id) === Number(this.operatorId)) || {}
      },
      ...mapGetters(
        [
          'currentOperator',
          'operators',
          'privilegeCategories'
        ]
      )
    },
    methods: {
      ...mapActions([
        'getGuestVisits',
        'getReports'
      ]),
      datePeriodIsCorrect (dateStart, dateEnd) {
        return moment(dateEnd).isSameOrAfter(moment(dateStart))
      },
      close: function () {
        this.$emit('close');
      },
      get_guest_full_name (guest) {
        let lastName = guest['last_name']
        let firstName = guest['first_name'][0]
        let middleName = guest['middle_name']
        return middleName ? lastName + " ".concat(firstName) + ". ".concat(middleName[0]) + "." : lastName + " ".concat(firstName) + "."
      },
      submitFile () {
        this.messages = null
        let formData = new FormData()
        formData.append('file', this.file)
        this.dataIsLoading = true
        this.axios.post('/api/operator/' + this.currentOperator.id + '/file/upload/',
          formData,
          {
            headers: {
              'Content-Type': 'application/form-data',
            }
          }
        ).then((response) => {
          if (response.status === 202) {
            this.guestVisits = response.data['data']['visits']
            this.dataIsLoading = false
          }
        })
          .catch((error) => {
            this.dataIsLoading = false
            this.guestVisits = null
            if (error.response.data['detail']) {
              this.$snotify.error(error.response.data['detail'])
            } else {
              this.$snotify.error('Ошибка импорта данных из файла!')
            }
          })
      },
      submitImport () {
        this.dataIsImporting = true
        axios.post('/api/guest_visits/list_create/', {records: this.guestVisits})
          .then((response) => {
            if (response.status === 201) {
              this.dataIsImporting = false
              this.$router.go(-1)
              this.$snotify.success('Cоздано записей: ' + response.data['records_created'] + ' Обновлено записей: ' + response.data['records_updated'], 'Успешно!')
            }
          })
          .catch((error) => {
            if (error.response.status >= 400) {
              this.dataIsImporting = false
              this.$snotify.error(error.response.data.detail, 'Ошибка!', {timeout: 10000})
            }
          })
      },
      handleFileUpload () {
        this.file = this.$refs.file.files[0]
        if (this.file) {
          this.submitFile()
        } else {
          this.guestVisits = null
        }
      },
      getPrivilegeCategoryCode: function (id) {
        return this.privilegeCategories.find(item => item.id === id).code
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/guests/ImportFromFile.vue